import { Portal, Switch } from '@mantine/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMap } from 'react-map-gl';

import styles from './switch-control.module.css';

/* eslint-disable-next-line */
export interface SwitchControlProps {
  checked: boolean;
  onChange: (value: boolean) => void;
  label: string;
  disabled?: boolean;
}

export function SwitchControl(props: SwitchControlProps) {
  const map = useMap();
  const mapId = map.current?.getMap().getContainer().id;

  const handleChange = (value: boolean) => {
    props.onChange?.(value);
  };

  if (!mapId) {
    return null;
  }

  return (
    <Portal
      target={
        document &&
        (document
          .getElementById(mapId)
          ?.getElementsByClassName('mapboxgl-ctrl-top-left')[0] as HTMLElement)
      }
    >
      <div className={`${styles['container']} mapboxgl-ctrl`}>
        <Switch
          checked={props.checked}
          disabled={props.disabled}
          label={props.label}
          labelPosition="right"
          onChange={(e) => handleChange(e.target.checked)}
        ></Switch>
      </div>
    </Portal>
  );
}

export default SwitchControl;
